/** Temporary UI toggles — flip to re-enable marketing plans & copy trading. */
export const FEATURE_FLAGS = {
  marketingPlansEnabled: true,
  copyTradeEnabled: true,
};
